import { render, staticRenderFns } from "./FormProjectModule.vue?vue&type=template&id=6b471d34&"
import script from "./FormProjectModule.vue?vue&type=script&lang=js&"
export * from "./FormProjectModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports